export default "__VITE_ASSET__CT_4zpiH__"